export const isCanonicalE164Phone = (raw: string): boolean => {
  const value = raw.trim();
  return /^\+\d{8,15}$/u.test(value);
};

export const sanitizePhoneForUserProfileUpdate = (
  phone: unknown,
): { phone?: string | null } => {
  if (phone === null) return { phone: null };
  if (typeof phone !== 'string') return {};

  const value = phone.trim();
  if (!value) return { phone: null };

  return isCanonicalE164Phone(value) ? { phone: value } : {};
};

export const sanitizeUserProfileUpdate = <T extends { phone?: unknown }>(
  profile: T,
): T => {
  if (!('phone' in profile)) return profile;

  const { phone: phoneValue, ...rest } = profile as { phone?: unknown };
  return {
    ...(rest as T),
    ...sanitizePhoneForUserProfileUpdate(phoneValue),
  };
};
